import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectUser } from "../../../core/auth/authSlice";
import { MembersApiRoutes } from "../../../shared/api-routes/member/members-api.routes";
import { User } from "../../../shared/models";
import http from "../../../shared/utils/http";
import "./JobDraft.scss";

import { JobDraftApiRoutes } from "../../../shared/api-routes/job/job-draft-api.routes";
import Button from "../../essentials/button/Button";
import ConfirmationModal from "../../essentials/modals/confirmation-modal/ConfirmationModal";
import { JobInfo } from "../Job";
// import EditModal from "./edit-job/EditJob";

export type JobProps = {
	jobInfo: JobInfo;
	onDeleteJob?: any;
	children?: any;
	user?: boolean;
};

export interface UserInfo {
	nationality: string;
	city: string;
	dob: string;
	height?: string;
	team: string;
}

const JobDraft: React.FC<JobProps> = ({
	jobInfo,
	children,
	user,
	onDeleteJob,
}) => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const { actorId } = useSelector(selectUser) as User;

	const [saved, setSaved] = useState(false);

	const [userInfo, setUserInfo] = useState<UserInfo>();

	useEffect(() => {
		if (jobInfo.author.accountType === "athlete")
			http.get(MembersApiRoutes.GET_USER(jobInfo.author.id)).then((res) => {
				setUserInfo(res);
			});
	}, [jobInfo.author.accountType, jobInfo.author.id]);

	const [isDeleteModalOpen, setDeleteModalOpen] = useState<boolean>();

	const deleteJob = () => {
		http.delete(JobDraftApiRoutes.DELETE_JOB_DRAFT(jobInfo.id)).then((res) => {
			setDeleteModalOpen(false);
			onDeleteJob(jobInfo.id);
		});
	};

	return (
		<div className={`job-draft-${jobInfo.author.accountType} job-draft`}>
			<div className="job-draft-main">
				<div className="job-draft__content">
					{jobInfo.author.accountType === "team" ? (
						<>
							<p className="job-draft__content-title ">
								{jobInfo.subject === "staff"
									? t(
											`sportData.positions.${jobInfo.subject}.${jobInfo.position}`
									  )
									: t(
											`sportData.positions.${jobInfo.sport}.${jobInfo.position}`
									  )}
							</p>
							<div className={"label-value"}>
								<p className={"label"}>{t("common.league")}: </p>
								<b className={"value"}>
									{jobInfo.league &&
										`${jobInfo.league.name} (${jobInfo.league.category})`}
								</b>
							</div>
							<div className={"label-value"}>
								<p className={"label"}>{t("common.words.city")}:</p>
								<b className={"value"}>{jobInfo.city}</b>
							</div>
							<div className="divider" />
							<p>{jobInfo.description}</p>
						</>
					) : (
						<>
							<p className="job-draft__content-title">
								{jobInfo.subject === "staff"
									? t(
											`sportData.positions.${jobInfo.subject}.${jobInfo.position}`
									  )
									: t(
											`sportData.positions.${jobInfo.sport}.${jobInfo.position}`
									  )}
							</p>
						</>
					)}
				</div>
			</div>

			<div className="actions">
				<Button
					className="btn btn-primary"
					action={() => {
						navigate("/create-job/" + jobInfo.id);
					}}
				>
					{t("common.buttons.complete") + " " + t("common.words.draft")}
				</Button>
				<Button
					className="btn btn-primary"
					action={() => setDeleteModalOpen(true)}
				>
					{t("common.buttons.delete") + " " + t("common.words.draft")}
				</Button>
			</div>
			{isDeleteModalOpen && (
				<ConfirmationModal
					title={`${t("common.buttons.delete")} ${t("common.words.draft")}?`}
					state={{
						isModalOpen: isDeleteModalOpen,
						setModalOpen: setDeleteModalOpen,
					}}
					onConfirm={deleteJob}
				/>
			)}
		</div>
	);
};

export default JobDraft;
